import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'toTarget',
	pure: true,
	standalone: true
})
export class TargetTranslatePipe implements PipeTransform {
	/**
	 * For history reason, the value of the linkTarget property in dynamic-content are self, newwindow, etc.
	 * The target property in the serialisedProperties is generally in HTML vlaue, such as _self, _blank.
	 * The differences causes confusion and make the dynamic content error prone.
	 * The method is used to handle the different.
	 */
	transform(value: string | null | undefined): string {
		switch (value?.toLowerCase()) {
			case 'newwindow':
			case '_blank':
				return '_blank';
			case 'selfnoajax':
			case 'self':
			case '_self':
			default:
				return '_self';
		}
	}
}
